
import { defineComponent, PropType, ref, toRef, watch } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZModal from "@/components/content/VZModal.vue";
import { IForm } from "@/interfaces/iForm";
import FormDetail from "@/views/form/views/FormDetail.vue";

export default defineComponent({
  name: "form-detail-modal",
  components: { VZModal, FormDetail },
  emits: ["close-detail"],
  props: {
    value: { type: Boolean, default: false },
    viewName: { type: String, default: "" },
    data: { type: Object as PropType<IForm>, required: true },
    loading: { type: Boolean, default: false },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const close = () => {
      emit("close-detail");
    };
    return {
      t,
      close,
    };
  },
});
